// src/utils/deviceDetection.ts
export const DeviceDetection = {
    // Check if running as PWA
    isPWA(): boolean {
      // Check for PWA display mode
      if (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) {
        return true;
      }
      
      // Check for PWA navigator standalone (iOS Safari)
      if ((window.navigator as any).standalone === true) {
        return true;
      }
      
      // Check for PWA document referrer
      if (document.referrer.includes('android-app://')) {
        return true;
      }
      
      return false;
    },
  
    // Check if on mobile device
    isMobile(): boolean {
      // Check screen size
      if (window.innerWidth <= 768) {
        return true;
      }
      
      // Check user agent for mobile indicators
      const userAgent = navigator.userAgent.toLowerCase();
      const mobileKeywords = [
        'android', 'iphone', 'ipad', 'ipod', 'blackberry', 
        'windows phone', 'mobile', 'tablet'
      ];
      
      return mobileKeywords.some(keyword => userAgent.includes(keyword));
    },
  
    // Check if we should hide notification components
    shouldHideNotifications(): boolean {
      return this.isMobile() || this.isPWA();
    }
  };
  